import { ModalManager } from '@Components/modal/ModalManager';
import { ModalProvider } from '@Hooks/modalManager/ModalProvider';
import { LayoutSwitcher } from '@Layout/LayoutSwitcher';
import { ErrorBoundary } from '@Services/observability/ErrorBoundary';
import { NameSuggestionModalWrapper } from '@Components/modal/nameTooLong/NameSuggestionModalWrapper';

export const RootComponent = () => {
  return (
    <>
      <ErrorBoundary>
        <ModalProvider>
          <ModalManager />
          <NameSuggestionModalWrapper />
          <LayoutSwitcher />
        </ModalProvider>
      </ErrorBoundary>
    </>
  );
};
